// extracted by mini-css-extract-plugin
module.exports = {"root":"StepsFooter_root__NNVUa","popup":"StepsFooter_popup__kMQKD","menu":"StepsFooter_menu__awJLo","fadeIn":"StepsFooter_fadeIn__3FiFM","spin":"StepsFooter_spin__KV5wA"};